var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "food",
    transform: "translate(-589 -1010)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(589 1010)",
    fill: "none",
    stroke: "#f0c807",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 170,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 160,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-food-750655",
    transform: "translate(557.713 1057.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M194.713,182.924l-23.919,36.36a19.25,19.25,0,0,1-12.24,8.242,18.573,18.573,0,0,1-3.617.36,17.638,17.638,0,0,1-9.926-3.033,17.96,17.96,0,0,1-7.77-12.194,18.329,18.329,0,0,1,3.525-14.014l32.9-42.671h0a4.5,4.5,0,0,1,7.118,5.5l-32.9,42.671a9.253,9.253,0,0,0,2.246,13.3,8.846,8.846,0,0,0,6.736,1.3,10.2,10.2,0,0,0,6.49-4.357l23.829-36.405a4.491,4.491,0,0,1,7.5,4.941Zm94.5-160.982c-8.377-5.974-19.764-6.423-32.025-1.234a76.476,76.476,0,0,0-31.328,26.365c-11.364,15.946-16.687,34.2-14.217,48.847a20.794,20.794,0,0,1-.876,10.106,4.5,4.5,0,1,0,8.511,2.9,29.816,29.816,0,0,0,1.236-14.486c-2.044-12.172,2.807-28.32,12.667-42.154h0A67.372,67.372,0,0,1,260.626,29c9.3-3.907,17.563-3.818,23.312.291s8.557,11.881,7.883,21.941l0,0a67.374,67.374,0,0,1-13.048,33.553C269,98.639,255.214,108.5,243.042,110.52a29.853,29.853,0,0,0-13.072,5.7,32.506,32.506,0,0,0-2.987,2.583,4.492,4.492,0,0,0,6.266,6.423,23,23,0,0,1,2.246-1.864,20.839,20.839,0,0,1,9.1-4c14.665-2.449,30.185-13.476,41.572-29.375v0a76.516,76.516,0,0,0,14.71-38.179c.808-13.272-3.324-23.895-11.657-29.87Zm-98.031,81.68a1.209,1.209,0,0,1,0-1.189A27.872,27.872,0,0,0,188.4,74.988L148.286,19.023a4.491,4.491,0,1,0-7.3,5.232l40.065,55.965a18.837,18.837,0,0,1,1.886,18.573,10.153,10.153,0,0,0,1.147,10.331L258.2,204.978h0a8.646,8.646,0,1,1-14.036,10.06L176.921,114.2a10.193,10.193,0,0,0-9.433-4.493,18.838,18.838,0,0,1-17-7.725l-40-55.829a4.492,4.492,0,1,0-7.3,5.232l40.043,55.945a27.832,27.832,0,0,0,25.155,11.431,1.216,1.216,0,0,1,1.123.426l67.15,100.818a17.5,17.5,0,0,0,11.5,7.59,17.968,17.968,0,0,0,3.211.293,17.631,17.631,0,0,0,13.9-28.411Zm-28.7-12.081a4.491,4.491,0,0,0,3.683-7.075L129.558,32.183a4.492,4.492,0,1,0-7.366,5.143L158.8,89.61h0a4.494,4.494,0,0,0,3.683,1.932Z",
    fill: "#2b215e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.f6fd0f41a699c6cea4995c59292c14a0.svg";
export { ForwardRef as ReactComponent };